import { render, staticRenderFns } from "./Yklist2.vue?vue&type=template&id=4b708344&scoped=true"
import script from "./Yklist2.vue?vue&type=script&lang=js"
export * from "./Yklist2.vue?vue&type=script&lang=js"
import style0 from "./Yklist2.vue?vue&type=style&index=0&id=4b708344&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b708344",
  null
  
)

export default component.exports